import { CONFIG } from '@/config';

export class Socket {

  public autoReconnectInterval = 5000;
  public pingInterval = 800;
  public callback: any;
  public instance: WebSocket;
  public queue = '';
  public pingServer: any;
  public tryingReconnect: any;

  constructor (queue: string, callback: any) {
    this.queue = queue;
    this.callback = callback;

    this.onClose = this.onClose.bind(this);
    this.onError = this.onError.bind(this);
    this.onMessage = this.onMessage.bind(this);
    this.onOpen = this.onOpen.bind(this);
    this.connect = this.connect.bind(this);
    this.log = this.log.bind(this);
    this.reconnect = this.reconnect.bind(this);
    this.send = this.send.bind(this);

    //this.connect();
  }

  public static blobToJson (blob: Blob) {
    const u = URL.createObjectURL(blob);
    const x = new XMLHttpRequest();
    x.open('GET', u, false);
    x.send();
    URL.revokeObjectURL(u);
    return JSON.parse(String(x.responseText));
  }

  public connect () {
    try {
      if (this.instance) {
        this.instance.removeEventListener('close', this.onClose);
        this.instance.removeEventListener('error', this.onError);
        this.instance.removeEventListener('message', this.onMessage);
        this.instance.removeEventListener('open', this.onOpen);
        delete this.instance;
      }

      this.instance = new WebSocket(
        `${CONFIG.URL.WEBSOCKET}?userName=${this.queue}`
      );

      this.instance.addEventListener('close', this.onClose);
      this.instance.addEventListener('error', this.onError);
      this.instance.addEventListener('message', this.onMessage);
      this.instance.addEventListener('open', this.onOpen);
    } catch (err) {
      console.error('ERROR: ', err);
    }
  }

  public reconnect (event: any) {
    try {
      if (!this.tryingReconnect) {
        // this.log(`retry in ${this.autoReconnectInterval}ms`, '#616161');
        this.tryingReconnect = setInterval(() => {
          if (this.instance.readyState === WebSocket.OPEN) {
            // this.log('Reconnected with success!', '#616161');
            clearInterval(this.tryingReconnect);
            this.tryingReconnect = undefined;
          }
          if (this.instance.readyState === WebSocket.CONNECTING) {
            // this.log('Already trying to reconnect…', '#616161');
          } else if (this.instance.readyState !== WebSocket.OPEN) {
            // this.log('Trying reconnect…', '#616161');
            this.connect();
          }
        }, this.autoReconnectInterval);
      }
    } catch (err) {
      console.log('ERROR: ', err, event);
    }
  }

  public send (data: any) {
    try {
      this.instance.send(data);
    } catch (err) {
      console.log('ERROR: ', err);
    }
  }

  public ping () {
    this.pingServer = setInterval(() => {
      if (this.instance.readyState === WebSocket.OPEN) {
        this.send('__ping__');
      }
    }, this.pingInterval);
  }

  public log (message: string, color: string, event?: string) {
    if (event !== undefined) {
      console.log(
        `WEB SOCKET: %c${message}`,
        `color:${color};font-weight:bold;`,
        event
      );
    } else {
      console.log(
        `WEB SOCKET: %c${message}`,
        `color:${color};font-weight:bold;`
      );
    }
  }

  public onClose (event: any) {
    this.log('DISCONNECTED', '#ffc107', event);
    switch (event.code) {
      case 1000: // CLOSE_NORMAL
        clearInterval(this.pingServer);
        this.onClose(event);
        break;
      default:
        // Abnormal closure
        this.reconnect(event);
        break;
    }
  }

  public onError (event: any) {
    this.log('ERROR', '#f44336', event);
    this.reconnect(event);
  }

  public onMessage (event: any) {
    const message = Socket.blobToJson(event.data);
    this.log('MESSAGE RECEIVED', '#00bcd4', message);
    this.callback(message);
  }

  public onOpen (event: any) {
    this.log('CONNECTED', '#4caf50');
    this.ping();
  }
}
